import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap-v5'
import SVG from 'react-inlinesvg'
import { defaultProfileImage } from '../../../../utils/constants';
import { formatDateShortIntl2 } from '../../../../helpers/FormatDate';
import { updateStatusIntroduction } from '../../../../services/introductionService';
import { IntroductionRequest, IntroductionStatus } from '../../models';
import { showErrorAlert } from '../../../../helpers/alert';

type Props = {
    introduction: IntroductionRequest;
    open: boolean;
    onCancel: () => void;
     onComplete: () => void;
}

export const DeclineModal: React.FC<Props> = ({ onCancel, onComplete, open, introduction }) => {
    const [isLoading,setIsLoading] = useState(false)
    
    const onAcceptHandle = async () => {
        setIsLoading(true)
        let params = {status:IntroductionStatus.REJECTED}
        let isAccepted = await updateStatusIntroduction(introduction.id,params)
        if(isAccepted.status == IntroductionStatus.REJECTED){
            showErrorAlert({title: "Action completed",message: "Introduction rejected"});
            onComplete()
            onCancel()
        }
    }

    return (<Modal show={open} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
        <div className="team-admin-add-member">
            {/* HEADER */}
            <div className="admin-experience-details-header text-center">
                <h2 className="tap-experience-nb-modal-title">
                    Reject Introduction Request
                </h2>
                <div className="rm-style-3 cursor-pointer" onClick={onCancel}>
                    <SVG src="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>
            {/* CONTENT */}
            <div className="d-flex flex-column">
                <div className="avatar-introduction-detail">
                    <div className="avatar-introduction-detail__header-no-border">
                        <img src={introduction?.requester?.avatar ?? defaultProfileImage} onError={(e) => {e.currentTarget.src = defaultProfileImage;}} className="avatar-introduction-detail__avatar" alt={introduction?.requester?.username} />
                        <div className="avatar-introduction-detail__name">
                            {introduction?.requester?.username}
                        </div>
                    </div>
                </div>
                <div className="introductions-card-no-actions">
                    {/* RIGHT CONTENT */}
                    <div className="introductions-card-details">

                        {/* HOSTS */}
                        <div className="tap-host-secction-experiences-past-host-group cursor-pointer justify-content-between">
                            <div className='w-50'>
                                <div className="tap-host-secction-experiences-past-info-text">Type</div>
                                <div className="tap-host-secction-experiences-past-info-text">{ introduction.type }</div>
                            </div>
                            <div className='w-50'>
                                <div className="tap-host-secction-experiences-past-info-text text-end">{ formatDateShortIntl2(introduction.dateRequest) }</div>
                                <div className="tap-host-secction-experiences-past-info-text text-end">
                                    <span>
                                        <SVG src="/media/svg/nobilis/clock.svg"></SVG> { introduction?.dateExpires }
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* INFO BOX */}
                        <div className="tap-host-secction-experiences-past-info-box">
                            <div className="tap-host-secction-experiences-past-info-row w-100">
                                <div className="tap-host-secction-experiences-past-info-text w-25">
                                    Topic
                                </div>
                                <div className="tap-host-secction-experiences-past-info-text w-75">
                                    {introduction.topic || ''}
                                </div>
                            </div>
                            <div className="border-bottom-line"></div>
                            <div className="tap-host-secction-experiences-past-info-row w-100">
                                <div className="tap-host-secction-experiences-past-info-text w-25">
                                    Message
                                </div>
                                <div className="tap-host-secction-experiences-past-info-text w-75">
                                    { introduction.message || 'N/A' }<br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="introduction-detail-accept">
                <div className="introduction-detail-accept__description">
                    They won’t be notified directly, but the request will be marked as rejected. You won’t be able to receive messages from them unless they try again later (if allowed).
                </div>
            </div>
            <div className="tap-host-secction-experiences-past-actions">
                <div className="tap-host-secction-experiences-past-buttons">
                    <div role='button' onClick={onCancel} className={`tap-add-experience-2-btn-secondary`}>
                        Cancel
                    </div>
                </div>
                <div className="tap-host-secction-experiences-past-buttons">
                    <button type='button' className="decline-experience__btn decline-experience__btn--primary" disabled={isLoading} onClick={onAcceptHandle}>
                        {isLoading ? 'submitting...' : 'Decline Request'}
                        <span className="svg-icon ">&nbsp;<SVG src='/media/svg/nobilis/vector02.svg' /></span>
                    </button>
                </div>
            </div>
        </div>
    </Modal>)
}
